import s from './Input.module.scss';

type InputProps<T> = Omit<
  React.InputHTMLAttributes<HTMLInputElement>,
  'value'
> & {
  name: string;
  label?: React.ReactNode;
  value: T;
  setValue?: (value: T) => void;
};
export const Input = <T,>({
  name,
  label,
  value,
  setValue,
  ...inputProps
}: InputProps<T>) => {
  const onSelect = (event: React.ChangeEvent<HTMLInputElement>) => {
    if (setValue) setValue(event.target.value as T);
  };

  return (
    <div className={s.input__wrapper}>
      {label && (
        <label htmlFor={name} className={s.input__label}>
          {label}
        </label>
      )}
      <input
        className={s.input}
        id={name}
        // @ts-expect-error I want generic types but HTML input complains. Fix later
        value={value}
        onChange={onSelect}
        {...inputProps}
      />
    </div>
  );
};
